export default "/images/certificate3.png?27e9858780e3dc2e117d468030eff846";